import { css } from '@emotion/react';
import { ScheduleTypes } from '@frontend/api-schedule';
import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { Heading } from '@frontend/design-system';
import { RequestContact } from '../BookingSite/RequestContact';

interface PreviewFormProps {
  customFields?: ScheduleTypes.CustomField[];
  overrideFields?: Partial<Record<keyof ScheduleTypes.PatientInfo, ScheduleTypes.CustomField>>;
  onUpdateForm: (form: ScheduleTypes.PatientInfo) => void;
  form: Partial<ScheduleTypes.PatientInfo>;
  fullsize?: boolean;
}

export function PreviewForm({ customFields, overrideFields, onUpdateForm, form }: PreviewFormProps) {
  const { t } = useTranslation('schedule');

  return (
    <div
      css={css({
        display: 'flex',
        flexDirection: 'column',
        h2: {
          margin: theme.spacing(2, 0),
        },
        '.request-contact': {
          flexGrow: 1,
        },
      })}
    >
      <Heading level={2}>{t('Appointment Request Form Preview')}</Heading>
      <RequestContact
        customFields={customFields}
        overrideFields={overrideFields}
        onChange={onUpdateForm}
        value={form}
      />
    </div>
  );
}
